<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Supplier</div>

    <Toolbar class="p-mb-2">
      <template slot="left">
        <Button
          label="Tambah"
          icon="pi pi-plus"
          class="p-button-success"
          @click="createSupplier()"
        />
      </template>
      <template slot="right"> </template>
    </Toolbar>

    <DataTable
      :value="suppliers"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading.filter"
      @page="getSuppliers($event)"
    >
      <template #header>
        <div
          class="p-grid p-fluid p-mb-2"
          v-if="
            $store.state.user.role === 'WAREHOUSE_MANAGER' ||
            $store.state.user.role === 'MAIN_PURCHASING' ||
            $store.state.user.role === 'PURCHASING'
          "
        >
          <div class="p-col-5 p-md-3 p-lg-2">
            <AutoComplete
              placeholder="Supplier"
              :dropdown="true"
              v-model="selectedSupplier"
              :suggestions="autoFilteredValue"
              @complete="searchSupplier($event)"
              field="code"
            >
              <template #item="slotProps">
                <div>{{ slotProps.item.name }}</div>
                <div style="font-style: italic; font-size: 12px">
                  {{ slotProps.item.code }}
                </div>
              </template>
            </AutoComplete>
          </div>
          <div class="p-col-5 p-md-3 p-lg-2">
            <Button
              label="Cari"
              class="p-button-info"
              @click="getSuppliers()"
              v-shortkey="['enter']"
              @shortkey="getSuppliers()"
            />
          </div>
        </div>
      </template>

      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>

      <Column field="code" header="Kode">
        <template #body="slotProps">
          {{ slotProps.data.code }}
        </template>
      </Column>
      <Column field="name" header="Nama">
        <template #body="slotProps">
          <span>{{ slotProps.data.name }}</span>
        </template>
      </Column>
      <Column field="address" header="Address">
        <template #body="slotProps">
          <span>{{ slotProps.data.address }}</span>
        </template>
      </Column>
      <Column field="origin" header="Origin">
        <template #body="slotProps">
          <span>{{ slotProps.data.origin ? slotProps.data.origin : '-' }}</span>
        </template>
      </Column>
      <Column field="phone" header="Phone">
        <template #body="slotProps">
          <span>{{
            slotProps.data.phone !== '0' ? slotProps.data.phone : '-'
          }}</span>
        </template>
      </Column>

      <Column>
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-mr-2"
            @click="editSupplier(slotProps.data)"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="confirmDelete(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="create_dialog"
      :style="{ width: '450px' }"
      header="Tambah Supplier"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="name">Nama</label>
        <InputText
          class="form-control"
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="address">Address</label>
        <InputText
          class="form-control"
          v-model="create_data.address"
          placeholder="Address"
          @keyup.prevent="is_error.address = false"
        />
        <small class="p-error" v-if="is_error.address">{{
          error_msg.origin
        }}</small>
      </div>
      <div class="p-field">
        <label for="phone">Phone</label>
        <InputText
          class="form-control"
          v-model="create_data.phone"
          placeholder="Phone"
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.origin
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Origin</label>
        <AutoComplete
          class="p-col"
          placeholder="Origin"
          :dropdown="true"
          :suggestions="origin_supplier"
          v-model="origin_selected"
          @complete="searchOriginSupplier($event)"
          field="origin"
          optionLabel="origin"
        >
          <template #item="slotProps">
            <div class="p-col">
              <div>{{ slotProps.item.origin }}</div>
            </div>
          </template>
        </AutoComplete>
        <small class="p-error" v-if="is_error.type">{{
          error_msg.origin
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Batal"
          class="p-button-outlined"
          @click="create_dialog = false"
        />
        <Button
          type="button"
          label="Tambah"
          class="btn btn-primary"
          @click="postSupplier()"
        >
          <span v-if="loading_tambah">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <Dialog
      :visible.sync="edit_dialog"
      :style="{ width: '450px' }"
      header="Edit Supplier"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="name">Nama</label>
        <InputText
          class="form-control"
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="address">Address</label>
        <InputText
          class="form-control"
          v-model="create_data.address"
          placeholder="Address"
          @keyup.prevent="is_error.address = false"
        />
        <small class="p-error" v-if="is_error.address">{{
          error_msg.address
        }}</small>
      </div>
      <div class="p-field">
        <label for="phone">Phone</label>
        <InputText
          class="form-control"
          v-model="create_data.phone"
          placeholder="Phone"
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Origin</label>
        <AutoComplete
          class="p-col"
          placeholder="Origin"
          :dropdown="true"
          :suggestions="origin_supplier"
          v-model="origin_selected"
          @complete="searchOriginSupplier($event)"
          field="origin"
          optionLabel="origin"
        >
          <template #item="slotProps">
            <div class="p-col">
              <div>{{ slotProps.item.origin }}</div>
            </div>
          </template>
        </AutoComplete>
        <small class="p-error" v-if="is_error.origin">{{
          error_msg.origin
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Batal"
          class="p-button-outlined"
          @click="edit_dialog = false"
        />
        <Button label="Simpan" class="btn btn-primary" @click="putSupplier()" />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="delete_dialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Hapus"
      :modal="true"
    >
      <div class="confirmation-content">
        Apakah kamu yakin ingin menghapus <b>{{ delete_data.code }}</b
        >?
      </div>

      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="delete_dialog = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteSupplier()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      delete_dialog: false,
      create_dialog: false,
      edit_dialog: false,
      loading_tambah: false,

      loading: {
        filter: false,
        create: false,
        edit: false,
        delete: false
      },

      jenisOrigin: [{ origin: 'MDN' }, { origin: 'LMD' }],

      origin_supplier: null,
      origin_selected: null,

      isError: {
        code: false,
        name: false,
        parent: false
      },

      suppliers: [],
      allSuppliers: [],
      filter: {
        code: '',
        name: ''
      },

      selectedSuppliers: null,
      selectedSupplier: { id: '', code: '', name: '' },
      autoFilteredValue: [],
      create_data: {
        name: '',
        address: '',
        origin: null
      },
      delete_data: {},

      is_error: {
        name: false,
        address: false,
        origin: null
      },

      error_msg: {
        name: '',
        address: '',
        origin: null
      },

      limit: 10,
      total_records: 0
    }
  },

  mounted() {
    this.getSuppliers(null, true)
  },

  methods: {
    async getSuppliers(event, useLimit = true) {
      let page = 1
      if (event) {
        page = event.page + 1
      }

      let sup_code = this.selectedSupplier.code
        ? this.selectedSupplier.code
        : ''

      let sup_name = ''

      if (this.selectedSupplier) {
        if (this.selectedSupplier.name) {
          sup_name = this.selectedSupplier.name
        } else if (!(this.selectedSupplier instanceof Object)) {
          sup_name = this.selectedSupplier
        } else {
          sup_name = ''
        }
      }

      this.loading.filter = true
      try {
        const limitParam = useLimit ? `&limit=${this.limit}` : ''
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers?code=${sup_code}&name=${sup_name}${limitParam}&page=${page}`
        )
        this.loading.filter = false
        if (response.status === 200) {
          if (useLimit) {
            this.suppliers = response.data.data.suppliers
          } else {
            this.allSuppliers = response.data.data.suppliers
          }
          this.total_records = response.data.data.total
        }
      } catch (error) {
        this.loading.filter = false
        console.error('Error fetching suppliers:', error)
      }
    },

    async searchSupplier(event) {
      if (!event.query) {
        this.autoFilteredValue = this.suppliers
        return
      }

      if (this.allSuppliers.length === 0) {
        await this.getSuppliers(null, false)
      }
      this.autoFilteredValue = this.allSuppliers.filter(item => {
        return (
          item.code.toLowerCase().includes(event.query.toLowerCase()) ||
          item.name.toLowerCase().includes(event.query.toLowerCase())
        )
      })
    },

    searchOriginSupplier(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.origin_supplier = [...this.jenisOrigin]
        } else {
          this.origin_supplier = this.jenisOrigin.filter(item => {
            return item.origin
              .toLowerCase()
              .startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    createSupplier() {
      this.create_dialog = true
      this.create_data.name = ''
      this.create_data.address = ''
      this.origin_selected = null
      this.is_error.name = false
      this.is_error.address = false
      this.is_error.origin = false
    },

    async postSupplier() {
      const validateInput = (field, errorField, errorMessage) => {
        if (this.create_data[field] === '') {
          this.is_error[errorField] = true
          this.error_msg[errorField] = errorMessage
          return false
        } else {
          if (field !== 'phone') {
            this.create_data[field] = this.create_data[field].toUpperCase()
          }
          return true
        }
      }

      const isNameValid = validateInput('name', 'name', 'Mohon isi nama')
      const isAddressValid = validateInput(
        'address',
        'address',
        'Mohon isi address'
      )
      const isPhoneValid = validateInput('phone', 'phone', 'Mohon isi phone')

      if (this.origin_selected) {
        this.create_data.origin = this.origin_selected.origin
      } else {
        this.is_error.origin = true
        this.error_msg.origin = 'Mohon isi origin'
      }

      if (
        isNameValid &&
        isAddressValid &&
        isPhoneValid &&
        this.create_data.origin
      ) {
        this.loading_tambah = true
        try {
          const response = await this.$http.post(
            `${process.env.VUE_APP_API_URL}/suppliers`,
            this.create_data
          )
          this.loading.create = false

          if (response.status === 200) {
            this.create_dialog = false
            this.getSuppliers()

            this.create_data = {
              name: '',
              address: '',
              origin: null,
              phone: ''
            }
            this.showToast(
              'success',
              'Berhasil Menambah Supplier',
              'Supplier berhasil ditambahkan'
            )
          } else {
            this.showToast(
              'error',
              'Gagal Menambah Supplier',
              'Supplier gagal ditambahkan'
            )
          }
        } catch (error) {
          console.error('Error adding supplier:', error)
          this.showToast(
            'error',
            'Gagal Menambah Supplier',
            'Terjadi kesalahan saat menambahkan supplier'
          )
        } finally {
          this.loading_tambah = false
        }
      } else {
        this.showToast(
          'error',
          'Gagal Menambah Supplier',
          'Nama, Alamat, Phone, dan Origin harus diisi'
        )
      }
    },

    editSupplier(supplier) {
      this.edit_dialog = true
      this.create_data.id = supplier.id
      this.create_data.name = supplier.name
      this.create_data.address = supplier.address
      this.create_data.phone = supplier.phone
      this.jenisOrigin.forEach(item => {
        if (item.origin == supplier.origin) {
          this.origin_selected = item.origin
          this.create_data.origin = item.origin
        } else {
          this.origin_selected = supplier.origin
          this.create_data.origin = supplier.origin
        }
      })
      this.is_error.name = false
      this.is_error.address = false
      this.is_error.origin = false
    },

    async putSupplier() {
      const validateInput = (field, errorField, errorMessage) => {
        if (this.create_data[field] === '') {
          this.is_error[errorField] = true
          this.error_msg[errorField] = errorMessage
          return false
        } else {
          if (field !== 'phone') {
            this.create_data[field] = this.create_data[field].toUpperCase()
          }
          return true
        }
      }

      const isAddressValid = validateInput(
        'address',
        'address',
        'Mohon isi address'
      )
      const isNameValid = validateInput('name', 'name', 'Mohon isi nama')
      const isPhoneValid = validateInput('phone', 'phone', 'Mohon isi phone')
      if (typeof this.origin_selected === 'object') {
        this.create_data.origin = this.origin_selected.origin
      } else if (typeof this.origin_selected === 'string') {
        this.create_data.origin = this.origin_selected
      } else {
        this.is_error.origin = true
        this.error_msg.origin = 'Mohon Pilih Origin'
      }

      if (
        isAddressValid &&
        isNameValid &&
        isPhoneValid &&
        this.create_data.origin
      ) {
        this.loading.edit = true
        try {
          const response = await this.$http.put(
            `${process.env.VUE_APP_API_URL}/suppliers/${this.create_data.id}`,
            this.create_data
          )
          this.loading.edit = false

          if (response.status === 200) {
            this.edit_dialog = false
            this.getSuppliers()

            this.create_data = {
              address: '',
              name: '',
              origin: null,
              phone: ''
            }

            this.showToast(
              'success',
              'Berhasil Edit Supplier',
              'Data supplier berhasil diupdate'
            )
          } else {
            this.showToast(
              'error',
              'Gagal Edit Supplier',
              'Data supplier gagal diupdate'
            )
          }
        } catch (error) {
          console.error('Error updating supplier:', error)
          this.showToast(
            'error',
            'Gagal Edit Supplier',
            'Terjadi kesalahan saat mengupdate supplier'
          )
        } finally {
          this.loading.edit = false
        }
      } else {
        this.showToast(
          'error',
          'Gagal Edit Supplier',
          'Nama, Alamat, Phone, dan Origin harus diisi'
        )
      }
    },

    confirmDelete(supplier) {
      this.delete_data = supplier
      this.delete_dialog = true
    },

    async deleteSupplier() {
      this.loading.edit = true
      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/suppliers/${this.delete_data.id}`
        )
        this.loading.edit = false
        this.delete_dialog = false

        if (response.status === 200) {
          this.getSuppliers()

          this.showToast(
            'success',
            'Berhasil Menghapus Supplier',
            'Supplier berhasil dihapus'
          )
        } else {
          this.showToast(
            'error',
            'Gagal Menghapus Supplier',
            'Supplier gagal dihapus'
          )
        }
      } catch (error) {
        this.loading.edit = false
        this.delete_dialog = false
        console.error('Error deleting supplier:', error)
        this.showToast(
          'error',
          'Gagal Menghapus Supplier',
          'Terjadi kesalahan saat menghapus supplier'
        )
      }
    }
  }
}
</script>
<style scoped>
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
